






































import { Component, Emit, Mixins, Prop } from "vue-property-decorator";
import { Corp, OfficeStaff } from "@/types/ibow2";
import AxiosMixin from "@/mixins/axiosMixin";
import Cookies from "js-cookie";
import HeaderCondition from "@/components/ibow2/officelist/corplist/HeaderCondition.vue";

@Component({ components: { HeaderCondition } })
export default class OfficeList extends Mixins(AxiosMixin) {
  @Prop({ default: () => ({}) }) private readonly corp!: Corp;

  @Prop({ default: () => ({}) }) private readonly item!: OfficeStaff;

  @Emit() private update() {
    return;
  }

  //招待承認
  private async inviteApprove(
    corp_name: string,
    item: OfficeStaff
  ): Promise<void> {
    if (
      !(await this.$openConfirm(
        corp_name + "からの招待を承認します。よろしいですか？"
      ))
    ) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/office/approve",
      {
        office_staff: item.office_staff
      },
      res => {
        if (res.data.token && res.data.ref_token) {
          window.token = res.data.token;
          Cookies.set("token", res.data.token, {
            domain: window.cookie_domain
          });
          window.reftoken = res.data.ref_token;
          Cookies.set("reftoken", res.data.ref_token, {
            domain: window.cookie_domain
          });
        }
        this.update();
      }
    );
  }

  //デフォルトにする
  private async clickDefault(item: OfficeStaff) {
    if (
      !(await this.$openConfirm(
        item.nick_name + "をデフォルト職員に設定します。よろしいですか？"
      ))
    ) {
      return;
    }
    this.postJsonCheck(
      window.base_url + "/api/office/to-default",
      {
        office_staff: item.office_staff
      },
      () => {
        this.update();
      }
    );
  }

  //iBowを使う
  private clickIbow(item: OfficeStaff) {
    //トークン保存
    this.postJsonCheck(
      window.base_url + "/api/auth/token",
      {
        office_staff_id: item.id
      },
      res => {
        window.token = res.data.token;
        Cookies.set("token", res.data.token, {
          domain: window.cookie_domain
        });
        window.reftoken = res.data.ref_token;
        Cookies.set("reftoken", res.data.ref_token, {
          domain: window.cookie_domain
        });
        location.href = window.ibow_frontend_url;
      }
    );
  }
}
